import React from 'react';

interface ErrorBoundaryState {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends React.Component<
  { children: React.ReactNode; fallback?: React.ReactNode },
  ErrorBoundaryState
> {
  constructor(props: { children: React.ReactNode; fallback?: React.ReactNode }) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('[ErrorBoundary] React crash:', error.message, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      const errMsg = this.state.error?.message || 'Nieznany b\u0142\u0105d';
      const errStack = this.state.error?.stack?.split('\n').slice(0, 4).join('\n') || '';
      // Always send error to backend for debugging
      try {
        fetch('/api/error-report', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ error: errMsg, stack: errStack, url: window.location.pathname }),
        }).catch(() => {});
      } catch (_) {}

      return (
        <div className="flex items-center justify-center min-h-[60vh] p-8">
          <div className="bg-white rounded-xl shadow-lg p-8 max-w-lg w-full text-center border border-red-100">
            <h2 className="text-xl font-bold text-gray-900 mb-2">Wystąpił błąd w module</h2>
            <pre className="text-left bg-red-50 text-red-800 p-3 rounded text-xs overflow-auto max-h-32 mb-4 whitespace-pre-wrap">{errMsg}</pre>
            <div className="flex gap-3 justify-center">
              <button
                onClick={() => { this.setState({ hasError: false, error: null }); window.location.reload(); }}
                className="bg-[#0f2a4d] text-white px-6 py-2.5 rounded-lg hover:bg-blue-800 transition-colors font-medium"
              >
                Odśwież stronę
              </button>
              <button
                onClick={() => { this.setState({ hasError: false, error: null }); window.location.href = '/dashboard'; }}
                className="bg-gray-100 text-gray-700 px-6 py-2.5 rounded-lg hover:bg-gray-200 transition-colors font-medium"
              >
                Pulpit
              </button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
